import { SocietyEquityMarketStatus } from 'types/Society';
import { EquityMarketAdminPanelContextType } from '../types/EquityMarketAdminPanelContextType';

export const equityMarketAdminPanelInitValue: EquityMarketAdminPanelContextType =
  {
    data: {
      societyId: '',
      societyName: '',
      equityMarketStatus: SocietyEquityMarketStatus.OPEN,
      sellOffers: [],
      buyOffers: [],
      activeSellOffers: [],
      activeBuyOffers: [],
      operations: [],
      sellOffersSummary: { offersCount: 0, sharesCount: 0, totalAmount: 0 },
      buyOffersSummary: { offersCount: 0, sharesCount: 0, totalAmount: 0 },
      pendingOperationsCount: 0,
      partners: [],
      isAdmin: false,
      isLoading: true,
    },
    actions: {
      handleGoBack: () => {},
      handleEquityMarketStatusChange: () => {},
      handleViewOfferDetail: () => {},
      handleViewOperationDetail: () => {},
      handleUpdateOperationStatus: () => {},
      handleTogglePartnerEquityMarketAccess: () => {},
    },
  };
